<template>
  <v-data-table
    hide-default-footer
    :items="getUncompletedIntegratedTransactions"
    :items-per-page="getUncompletedIntegratedTransactions.length + 1"
    :headers="headers"
    :mobile-breakpoint="0"
    :loading="loading"
    sort-by="created"
    :sort-desc="true"
  >
    <template v-slot:item.quantity="{ item }">
      {{ Number(item.quantity) }}
    </template>
    <template v-slot:item.date="{ item }">
      {{ item.date | shortLocalFormat }}
    </template>
    <template v-slot:item.created="{ item }">
      {{ item.created | localFormat }}
    </template>
    <template v-slot:item.actions="{ item }">
      <v-row align="center" justify="end" no-gutters>
        <InventoryTransactionProductAssigner
          :item="item"
          :loading="loading"
          @update="getData"
        ></InventoryTransactionProductAssigner>
        <v-btn small icon class="ml-2" @click="deleteTransaction(item)">
          <v-icon small>fa-trash</v-icon>
        </v-btn>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
import InventoryTransactionProductAssigner from "./InventoryTransactionProductAssigner";
export default {
  name: "InventoryTransactionList",
  components: {
    InventoryTransactionProductAssigner
  },
  computed: {
    ...mapGetters(["getUncompletedIntegratedTransactions"])
  },
  data() {
    return {
      loading: false,
      headers: [
        { value: "product_key", text: "Clé de produit" },
        { value: "quantity", text: "Quantité" },
        { value: "date", text: "Date" },
        { value: "created", text: "Créé le" },
        { value: "actions", text: "", sortable: false }
      ]
    };
  },
  methods: {
    async deleteTransaction(item) {
      const allow = await this.$dialog.confirm({
        text: "Voulez-vous vraiment supprimer cette transaction?",
        title: ""
      });
      if (allow) {
        try {
          this.loading = true;
          const d = {
            ...item,
            is_deleted: true
          };
          await api.updateIntegratedTransaction(item.id, d);
          await this.getData();
        } finally {
          this.loading = false;
        }
      }
    },
    async getData() {
      try {
        this.loading = true;
        await this.$store.dispatch("loadIntegratedTransactions", {
          uncompleted: true,
          deleted: false
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style></style>
